// Orange accent dot appended after Renewal Click's main screen titles (Offer, Payment, ...).
export const titleAccentDot = {
  content: '""',
  display: 'inline-block',
  width: '0.22em',
  height: '0.22em',
  borderRadius: '50%',
  backgroundColor: 'primary.main',
  marginInlineStart: '0.1em',
  verticalAlign: '0.1em',
};
